import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Form, InputGroup, Button, Table } from "react-bootstrap";
// @ts-ignore
import "../../styles/pos.css";
import { fetchCategoriesApi } from "../../api/fetchCategories";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { fetchProductsApi } from "../../api/fetchProducts";
import placeholderImg from "../../assets/images/image-placeholder.jpg";
import { fmtMoney } from "../../methods/commonMethods";
import { Cart, Grid, List, Search } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import ProductOptionsModal from "./ProductOptionsModal";
import PaymentOptionsModal from "./PaymentOptionsModal";

const DEFAULTCATEGORIES = [
  {
    id: "-1",
    image: {
      id: "-1",
      src: null,
    },
    name: "ALL",
    subcategories: [],
  },
];

/**
 * @param {string} value
 * @param {number} delay
 * @returns {string}
 */
function useDebouncedValue(value, delay = 400) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}

/**
 * @param {{ mainCatId: string|null, categoryId: string|null, search: string|null }} args
 */
function useCategoryProducts({ mainCatId, categoryId, search }) {
  return useInfiniteQuery({
    queryKey: ["products", mainCatId, categoryId, search || null],
    queryFn: ({ pageParam }) =>
      fetchProductsApi({
        maincat: mainCatId,
        category: categoryId,
        search: search,
        page: pageParam,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => lastPage.nextPage ?? undefined,
    staleTime: 15 * 60 * 1000, // don't refetch on tab switch for 15 min
  });
}

// /

const NUMPAD_ROWS = [
  ["1", "2", "3", "Qty"],
  ["4", "5", "6", "Disc"],
  ["7", "8", "9", "Price"],
  ["+/-", "0", ".", "Del"],
];

// const currency = (value) => `KES ${value.toFixed(2)}`;

export default function AddSale() {
  const [productView, setProductView] = useState("LIST");
  const [activeCategory, setActiveCategory] = useState("-1");
  const [activeCategoryKey, setActiveCategoryKey] = useState("-1"); //main, sub

  const [activeSub, setActiveSub] = useState("-1");
  const [cart, setCart] = useState(
    /** @type {import("../../models/LineItemModel").LineItemModel[]} */ ([]),
  );
  const [entry, setEntry] = useState("");

  const [searchT, setSearchT] = useState("");

  const [showPayment, setShowPayment] = useState(false);

  const [modalProduct, setModalProduct] = useState(
    /** @type {import("../../models/ProductModel").ProductModel | null} */ (
      null
    ),
  );

  const debouncedSearch = useDebouncedValue(searchT, 400);

  const effectiveSearch = useMemo(
    () => (debouncedSearch.length >= 3 ? debouncedSearch : ""),
    [debouncedSearch],
  );

  const {
    data: categories = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["categories"],
    queryFn: fetchCategoriesApi,
    staleTime: 1000 * 60 * 15,
  });

  /** @type {import("../../models/CategoryModel").CategoryModel[]} */
  const filteredCategories = useMemo(() => {
    return [...DEFAULTCATEGORIES, ...categories];
  }, [categories]);

  //   console.log(filteredCategories);

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading: isLoadingProducts,
  } = useCategoryProducts({
    mainCatId: activeCategoryKey === "main" ? activeCategory : null,
    categoryId: activeCategoryKey === "sub" ? activeSub : null,
    search: effectiveSearch,
  });

  //   console.log(data);

  /** @type {import("../../models/ProductModel").ProductModel[]} */
  const activeProducts = useMemo(
    () => data?.pages.flatMap((page) => page.items) ?? [],
    [data],
  );

  //   console.log(activeProducts);

  // const addToCart = (product) => {
  //   setCart((prev) => {
  //     const existing = prev.find((line) => line.id === product.id);
  //     if (existing) {
  //       return prev.map((line) =>
  //         line.id === product.id ? { ...line, qty: line.qty + 1 } : line,
  //       );
  //     }
  //     return [...prev, { ...product, qty: 1 }];
  //   });
  // };

  /** @param {{ lineItem : import("../../models/LineItemModel").LineItemModel}} args */
  const handleAddFromModal = ({ lineItem }) => {
    setCart((prev) => {
      // const existing = prev.find(
      //   (line) =>
      //     line.id === product.id &&
      //     line.locationId === locationId &&
      //     line.notes === notes,
      // );
      // if (existing) {
      //   return prev.map((line) =>
      //     line === existing ? { ...line, qty: line.qty + quantity } : line,
      //   );
      // }
      return [...prev, lineItem];
    });
    setModalProduct(null);
  };

  /** @param {Number} index */
  const removeLine = (index) => {
    setCart((prev) => prev.toSpliced(index, 1));
  };

  const subtotal = cart.reduce((sum, l) => sum + l.subtotal, 0);

  const total = cart.reduce((sum, l) => sum + l.total, 0);
  const taxes = cart.reduce((sum, l) => sum + l.total_tax, 0);

  /** @param {string} key */
  const handleNumpad = (key) => {
    if (!key) return;
    if (key === "Del") {
      setEntry((e) => e.slice(0, -1));
      return;
    }
    if (["Customer", "Qty", "Disc", "Payment", "Price", "+/-"].includes(key)) {
      // Placeholder hooks for real POS actions — wire these up as needed.
      return;
    }
    setEntry((e) => (e.length < 10 ? e + key : e));
  };

  const placeOrder = () => {};

  return (
    <>
      <div className="pos-app d-flex">
        <div className="pos-sidebar">
          <div className="pos-sidebar-header">
            <div className="d-flex align-items-center">
              <span className="pos-brand">SBA P.O.S.</span>
            </div>
            <span className="pos-admin-pill">Administrator</span>
          </div>

          {/* Scrollable line items */}
          <div className="pos-lineitems">
            {cart.length === 0 && (
              <div className="pos-empty">
                No items yet — tap a product to add it.
              </div>
            )}
            {cart.map((line, index) => (
              <div className="pos-line" key={index}>
                <div>
                  <div className="pos-line-name">{line.name}</div>
                  <div className="pos-line-sub">
                    {line.quantity} {line.unit} @ {fmtMoney(line.price)}/
                    {line.unit}
                  </div>
                  <div className="pos-line-sub">
                    Location :{" "}
                    {
                      line.meta_data
                        .find((v) => v.key.includes("sba_store"))
                        ?.key.split(">>")[1]
                    }{" "}
                  </div>
                  {line.meta_data.filter((a) => a.key.includes("sba_accomp"))
                    .length > 0 && (
                    <div className="pos-line-sub">
                      Accompaniment :{" "}
                      {
                        line.meta_data
                          .find((v) => v.key.includes("sba_accomp"))
                          ?.key.split(">>")[1]
                      }{" "}
                    </div>
                  )}
                  {line.meta_data.filter((a) => a.key.includes("__sba_pref"))
                    .length > 0 && (
                    <div className="pos-line-sub">
                      Notes :{" "}
                      {line.meta_data
                        .filter((a) => a.key.includes("__sba_pref"))
                        .map((m) => {
                          return <span> {m.key.split(">>")[1]}, </span>;
                        })}
                    </div>
                  )}

                  <div className="pos-line-sub"></div>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <span className="pos-line-price">
                    {fmtMoney(line.quantity * line.price)}
                  </span>
                  <button
                    className="pos-line-remove"
                    onClick={() => removeLine(index)}
                  >
                    ✕
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="pos-totals">
            <div className="pos-total-label">Total: {fmtMoney(total)}</div>
            {/* <div className="pos-taxes">Sub Total: {fmtMoney(subtotal)}</div>
            <div className="pos-taxes">Taxes: {fmtMoney(taxes)}</div> */}
          </div>

          <div className="pos-divider" />

          <div className="pos-numpad">
            {entry !== "" && <div className="pos-numpad-entry">{entry}</div>}
            {NUMPAD_ROWS.map((row, rIdx) => (
              <div className="pos-numpad-row" key={rIdx}>
                {row.map((key, kIdx) => {
                  const isLabel = ["Qty", "Disc", "Price", "Del"].includes(key);
                  return (
                    <button
                      key={kIdx}
                      className={[
                        "pos-key",
                        isLabel ? "pos-key--label" : "",
                        key === "" ? "pos-key--hidden" : "",
                      ].join(" ")}
                      disabled={key === ""}
                      onClick={() => handleNumpad(key)}
                    >
                      {key}
                    </button>
                  );
                })}
              </div>
            ))}
            <div className="pos-actions">
              <button
                className={[
                  "pos-key",
                  "pos-key--label",
                  "pos-actions-btn",
                ].join(" ")}
                onClick={() => {
                  setCart([]);
                }}
              >
                EMPTY <Cart />
              </button>
              <button
                className={[
                  "pos-key",
                  "pos-key--label",
                  "pos-actions-btn",
                ].join(" ")}
                onClick={() => setShowPayment(true)}
                disabled={cart.length < 1}
              >
                ORDER
              </button>
            </div>
          </div>
        </div>

        <div className="pos-main">
          <div className="pos-topbar">
            <div className="d-flex align-items-center">
              <span className="pos-count-badge">{cart.length}</span>
            </div>

            <div className="d-flex align-items-center gap-3">
              <Link to={"/"} className="pos-close-btn">
                Close
              </Link>
            </div>
          </div>

          {/* Scrollable (horizontally) category row */}
          <div className="pos-catrow">
            {filteredCategories.map((cat) => (
              <button
                key={cat.id}
                className={`pos-chip pos-chip--cat ${activeCategory === cat.id ? "active" : ""}`}
                onClick={() => {
                  setActiveCategoryKey(cat.id !== "-1" ? "main" : "-1");
                  setActiveCategory(cat.id);
                }}
              >
                {cat.name}
              </button>
            ))}
          </div>

          {/* Scrollable (horizontally) subcategory row */}
          <div className="pos-subrow">
            <button
              key={"-1"}
              className={`pos-chip pos-chip--sub ${activeCategoryKey === "main" || activeCategoryKey === "-1" ? "active" : ""}`}
              onClick={() => {
                setActiveCategoryKey("main");
              }}
            >
              ALL
            </button>
            {(
              (filteredCategories ?? []).find((c) => c.id === activeCategory)
                ?.subcategories ?? []
            ).map((s) => (
              <button
                key={s.id}
                className={`pos-chip pos-chip--sub ${activeCategoryKey === "sub" && activeSub === s.id ? "active" : ""}`}
                onClick={() => {
                  setActiveCategoryKey("sub");
                  setActiveSub(s.id);
                }}
              >
                {s.name}
              </button>
            ))}
          </div>

          <div className="pos-searchrow">
            <div className="pos-product-view">
              <button
                className={`pos-product-view-toggle ${productView === "GRID" ? "active" : ""}`}
                onClick={() => {
                  setProductView("GRID");
                }}
              >
                <Grid />
              </button>
              <button
                className={`pos-product-view-toggle ${productView === "LIST" ? "active" : ""}`}
                onClick={() => {
                  setProductView("LIST");
                }}
              >
                <List />
              </button>
            </div>

            <InputGroup className="pos-search">
              <Form.Control
                value={searchT}
                onChange={(v) => setSearchT(v.target.value)}
                placeholder="Search products"
              />
              <InputGroup.Text>
                {" "}
                <Search />{" "}
              </InputGroup.Text>
            </InputGroup>
          </div>

          {/* Scrollable product grid */}

          {productView === "GRID" ? (
            <div className="pos-productgrid">
              <Row className="g-3">
                {(activeProducts ?? []).map((product) => {
                  // console.log(product?.images[0]?.src);
                  return (
                    <Col xs={6} sm={4} md={3} xl={2} key={product.id}>
                      <div
                        className="pos-card"
                        onClick={() => {
                          setModalProduct(product);
                          // addToCart(product)
                        }}
                      >
                        <div className="pos-card-image">
                          <img
                            src={
                              (product?.images ?? []).length > 0
                                ? product?.images[0]?.src
                                  ? `data:image/png;base64,${product?.images[0]?.src}`
                                  : placeholderImg
                                : placeholderImg
                            }
                            alt={product.name}
                          />
                          <span className="pos-price-badge">
                            {fmtMoney(product.price)}
                          </span>
                        </div>
                        <div className="pos-card-name">{product.name}</div>
                      </div>
                    </Col>
                  );
                })}

                {activeProducts.length === 0 ? (
                  isLoadingProducts ? (
                    <Col xs={12}>
                      <p className="pos-empty">Loading products ....</p>
                    </Col>
                  ) : (
                    <Col xs={12}>
                      <p className="pos-empty">
                        No products in this category yet.
                      </p>
                    </Col>
                  )
                ) : (
                  <></>
                )}
                <p></p>
              </Row>
              {hasNextPage && (
                <Col className="pos-load-more" xs={12}>
                  <Button
                    onClick={() => fetchNextPage()}
                    disabled={isFetchingNextPage}
                  >
                    {isFetchingNextPage ? "Loading more…" : "Load more"}
                  </Button>
                </Col>
              )}
            </div>
          ) : (
            // <div className="pos-productlist">
            <>
              <Table hover responsive size="sm" className="pbi-table mb-0">
                <thead className="sticky-top bg-white">
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  {(activeProducts ?? []).map((product) => {
                    return (
                      <tr
                        key={product.id}
                        onClick={() => {
                          setModalProduct(product);
                          // addToCart(product)
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <td>{product.id}</td>
                        <td>{product.name}</td>
                        <td>{fmtMoney(product.price)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <div style={{ margin: "2px" }}></div>
              {activeProducts.length === 0 ? (
                isLoadingProducts ? (
                  <Col xs={12}>
                    <p className="pos-empty">Loading products ....</p>
                  </Col>
                ) : (
                  <Col xs={12}>
                    <p className="pos-empty">
                      No products in this category yet.
                    </p>
                  </Col>
                )
              ) : (
                <></>
              )}

              {hasNextPage && (
                <Col className="pos-load-more load-more-list" xs={12}>
                  <Button
                    onClick={() => fetchNextPage()}
                    disabled={isFetchingNextPage}
                  >
                    {isFetchingNextPage ? "Loading more…" : "Load more"}
                  </Button>
                </Col>
              )}
              {/* </div> */}
            </>
          )}
        </div>
      </div>
      <ProductOptionsModal
        show={!!modalProduct}
        product={modalProduct}
        onCancel={() => setModalProduct(null)}
        onAdd={handleAddFromModal}
      />
      <PaymentOptionsModal
        show={showPayment}
        onCancel={() => setShowPayment(false)}
      />
    </>
  );
}
